module.exports = __webpack_public_path__ + "static/media/Roster.7e2d5feb.md";